import { toast as toastify } from 'react-toastify';

const DEFAULT_AUTO_CLOSE_MS = 3000;

// Chấp nhận cả 2 cách gọi quen thuộc đã dùng trong code (kiểu antd message cũ):
// toast.success('text') hoặc toast.success({ content, key, duration }) — duration tính bằng giây.
function normalizeArgs(args) {
  if (args[0] && typeof args[0] === 'object') {
    const { content, key, duration } = args[0];
    return { content, key, duration };
  }
  return { content: args[0], key: undefined, duration: args[1] };
}

function toAutoClose(duration) {
  if (duration === 0) return false; // 0 giây = không tự đóng (dùng cho loading)
  if (duration == null) return DEFAULT_AUTO_CLOSE_MS;
  return Math.round(duration * 1000);
}

function show(type, args) {
  const { content, key, duration } = normalizeArgs(args);
  const toastId = key;

  // Toast "loading" đang tồn tại cùng key -> cập nhật thành success/error/... tại chỗ
  // (giữ đúng pattern: loading khi đang xử lý, rồi thay bằng kết quả cùng vị trí).
  if (toastId && toastify.isActive(toastId)) {
    toastify.update(toastId, {
      render: content,
      type: type === 'loading' ? 'default' : type,
      isLoading: type === 'loading',
      autoClose: type === 'loading' ? false : toAutoClose(duration),
    });
    return toastId;
  }

  if (type === 'loading') {
    return toastify.loading(content, { toastId });
  }

  return toastify[type](content, { toastId, autoClose: toAutoClose(duration) });
}

/**
 * Toast thông báo dùng chung cho toàn site (react-toastify), hiển thị ở góc dưới bên phải.
 * Giữ nguyên chữ ký gọi hàm như trước (chuỗi text hoặc object { content, key, duration })
 * để tương thích với các chỗ đã dùng, kể cả pattern loading -> success/error cùng key.
 */
export const toast = {
  success: (...args) => show('success', args),
  error: (...args) => show('error', args),
  warning: (...args) => show('warning', args),
  info: (...args) => show('info', args),
  loading: (...args) => show('loading', args),
  open: (...args) => show('info', args),
  destroy: (key) => (key ? toastify.dismiss(key) : toastify.dismiss()),
};

export default toast;
